// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","footer_wrapper":"footer_wrapper-2hPyt","checkboxes_wrapper":"checkboxes_wrapper-2PtqU"};